import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Icon,
  Image,
  Input,
  SimpleGrid,
  Text,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useEffect, useState } from "react";
import cr from "../lib/request";
import Container from "../components/Container";
import RequiredForm from "../components/form/RequiredForm";
import PasswordInput from "../components/form/PasswordInput";
// import AlertRegister from "../components/AlertRegister";
import Nav from "../components/nav/Nav";
import useKubuBanner from "../globalState/useKubuBanner";
import Footer from "../components/Footer";
import { CheckCircle } from "@phosphor-icons/react";

export default function Register() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [loading, setLoading] = useState<boolean>(false);
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const toast = useToast();
  const { show } = useKubuBanner();

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      username: "",
      password: "",
      name: "",
      email: "",
      phone: "",
    },

    validationSchema: yup.object().shape({
      username: yup.string().required("Username harus diisi"),
      password: yup.string().required("Password harus diisi"),
      name: yup.string().required("Nama harus diisi"),
      email: yup.string().required("Email harus diisi"),
      phone: yup.string().required("Telepon harus diisi"),
    }),

    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      const url = `api/usercourse/register`;
      const payload = values;

      cr.post(url, payload)
        .then((response) => {
          if (response.status === 201) {
            setEmailSent(true);
            toast({
              title: "Berhasil membuat akun",
              description: response.data.message,
              status: "success",
              duration: 10000,
              isClosable: true,
            });
            resetForm();
          }
        })
        .catch((error) => {
          console.log(error);
          toast({
            title: "Gagal membuat akun",
            description: error?.response?.data?.message,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <VStack align={"stretch"} minH={"100vh"} gap={0}>
      <Nav />

      <Container mx={"auto"} my={"auto"} p={"0 !important"}>
        {!emailSent && (
          <VStack
            my={show ? "calc(72px + 82px)" : "82px"}
            boxShadow={"0 0 0 1px var(--divider3)"}
            align={"stretch"}
            gap={0}
          >
            <SimpleGrid columns={[1, null, 2]}>
              <VStack
                align={"stretch"}
                bg={"var(--divider)"}
                p={8}
                justify={"center"}
              >
                <Image src="/vectors/course.svg" />
                <Text
                  textAlign={"center"}
                  fontSize={32}
                  fontWeight={600}
                  maxW={"400px"}
                  mx={"auto"}
                  lineHeight={1.2}
                >
                  Ayo daftarkan dirimu di Kubu Online Course
                </Text>
              </VStack>

              <VStack align={"stretch"} p={8}>
                <Heading mb={4}>Daftar Gratis</Heading>

                <form id={"daftar"} onSubmit={formik.handleSubmit}>
                  <FormControl
                    mb={4}
                    isInvalid={formik.errors.username ? true : false}
                  >
                    <FormLabel>
                      Username
                      <RequiredForm />
                    </FormLabel>
                    <Input
                      name="username"
                      onChange={formik.handleChange}
                      placeholder="Masukkan username (digunakan untuk sign in)"
                      value={formik.values.username}
                    />
                    <FormErrorMessage>
                      {formik.errors.username}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                    mb={4}
                    isInvalid={formik.errors.password ? true : false}
                  >
                    <FormLabel>
                      Password
                      <RequiredForm />
                    </FormLabel>
                    <PasswordInput
                      name="password"
                      formik={formik}
                      placeholder="Masukkan kata sandi untuk akun ini"
                    />
                    <FormErrorMessage>
                      {formik.errors.password}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                    mb={4}
                    isInvalid={formik.errors.name ? true : false}
                  >
                    <FormLabel>
                      Nama
                      <RequiredForm />
                    </FormLabel>
                    <Input
                      name="name"
                      onChange={formik.handleChange}
                      placeholder="Masukkan nama lengkap"
                      value={formik.values.name}
                    />
                    <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    mb={4}
                    isInvalid={formik.errors.email ? true : false}
                  >
                    <FormLabel>
                      Email
                      <RequiredForm />
                    </FormLabel>
                    <Input
                      name="email"
                      onChange={formik.handleChange}
                      placeholder="Masukkan telepon"
                      value={formik.values.email}
                    />
                    <FormErrorMessage>{formik.errors.email}</FormErrorMessage>
                  </FormControl>

                  <FormControl
                    mb={4}
                    isInvalid={formik.errors.phone ? true : false}
                  >
                    <FormLabel>
                      Telepon
                      <RequiredForm />
                    </FormLabel>
                    <Input
                      name="phone"
                      onChange={formik.handleChange}
                      placeholder="Masukkan telepon"
                      value={formik.values.phone}
                    />
                    <FormErrorMessage>{formik.errors.phone}</FormErrorMessage>
                  </FormControl>
                </form>

                <Button
                  mt={2}
                  colorScheme="p"
                  h={"50px"}
                  className="clicky"
                  type="submit"
                  form="daftar"
                  isLoading={loading}
                >
                  Buat Akun
                </Button>
              </VStack>
            </SimpleGrid>

            {/* <AlertRegister /> */}
          </VStack>
        )}

        {emailSent && (
          <VStack p={10} w={"100%"}>
            <Icon
              as={CheckCircle}
              fontSize={150}
              weight={"thin"}
              color={"p.500"}
            />
            <Text
              fontSize={32}
              fontWeight={600}
              color={"p.500"}
              textAlign={"center"}
            >
              Tautan verifikasi email telah dikirim di email yang anda daftarkan{" "}
              {formik.values.email}
            </Text>
            <Text fontSize={20} textAlign={"center"}>
              Silahkan cek email anda
            </Text>
          </VStack>
        )}
      </Container>

      <Footer />
    </VStack>
  );
}
